import { Project } from './Project';
import './ProjectCard.css'
import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useEffect, useRef } from 'react';

const BLOB_BASE = "https://lbhportfolioimages.blob.core.windows.net/images/";

// Bare file names are served from blob storage; anything with a path (e.g. "assets/x.gif") is served from public/.
function mediaSrc(name: string): string {
    return name.includes('/') ? name : BLOB_BASE + name;
}

interface MyCarouselProps {
    project: Project;
}

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    },
};


function MyCarousel(props: MyCarouselProps) {

    const project = props.project;
    const images = project.images;

    const carouselRef = useRef<Carousel | null>(null);

    useEffect(() => {
        carouselRef.current?.goToSlide(0);
    });

    if (images[0] === 'no_image.jpg') {
        return (
            <Carousel
                ref={carouselRef}
                responsive={responsive}
                swipeable={false}
                draggable={false}
                showDots={false}
                infinite={false}
                containerClass="cardCarouselWrapper"
                sliderClass="cardCarouselList"
            >
                <img draggable="false" key="1" src={mediaSrc(images[0])} alt={project.name} className="cardImg" />
            </Carousel>
        );
    } else {
        return (
            <Carousel
                ref={carouselRef}
                responsive={responsive}
                autoPlay={false}
                swipeable={true}
                draggable={true}
                showDots={true}
                infinite={false}
                containerClass="cardCarouselWrapper"
                sliderClass="cardCarouselList"
            >
                {images.map((mediaUrl, index) => {
                    if (/\.(mp4|webm|mov)$/i.test(mediaUrl)) {
                        return (
                            <video key={index} src={mediaSrc(mediaUrl)} className="cardImg" controls muted playsInline preload="metadata" />
                        );
                    }
                    return (
                        <img draggable="false" key={index} src={mediaSrc(mediaUrl)} alt={project.name} className="cardImg" />
                    );
                })}
            </Carousel>
        );
    }
}

export default MyCarousel;